import { IPublicClientApplication } from '@azure/msal-browser';

import { _clientSettings } from '../utils/client/client-settings';
import { aquireToken } from './authentication-provider';

import {
	AdminApi,
	BookedForSalesApi,
	Configuration,
	CustomerApi,
	OrderApi,
	ProductApi,
	LimitedEditionApi,
	QuotaApi,
	SystemApi,
} from '../api-client';

const baseAPIUrl = _clientSettings.baseApiUrl;

export const BookedForSalesApiClient = async (
	instance: IPublicClientApplication,
) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new BookedForSalesApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};

export const CustomerApiClient = async (instance: IPublicClientApplication) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new CustomerApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};

export const OrderApiClient = async (instance: IPublicClientApplication) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new OrderApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};

export const ProductApiClient = async (instance: IPublicClientApplication) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new ProductApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};

export const SystemApiClient = async (instance: IPublicClientApplication) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new SystemApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};

export const AdminApiClient = async (instance: IPublicClientApplication) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new AdminApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};

export const QuotaApiClient = async (instance: IPublicClientApplication) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new QuotaApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};

export const LimitedEditionApiClient = async (instance: IPublicClientApplication) => {
	const acquireTokenResponse = await aquireToken(instance);

	return new LimitedEditionApi({
		basePath: baseAPIUrl,
		baseOptions: {
			headers: {
				Authorization: `Bearer ${acquireTokenResponse.accessToken}`,
			},
			timeout: _clientSettings.timeout,
		},
		isJsonMime: Configuration.prototype.isJsonMime,
	});
};
